import { render, staticRenderFns } from "./ModelActive.vue?vue&type=template&id=4910a81d&scoped=true"
import script from "./ModelActive.vue?vue&type=script&lang=js"
export * from "./ModelActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910a81d",
  null
  
)

export default component.exports